"use strict";

var request = require('./request');
var galleryAPIUtils = {};

galleryAPIUtils.getGal = function(data) {

    return request('/server/api/galerija', {
        method: 'GET',
        data: {galerija:'galerija'}
    });
};

galleryAPIUtils.getImg = function(data) {

    return request('/server/api/galerija', {
        method: 'GET',
        data: {id:data  }
    });
};
module.exports = galleryAPIUtils;



/** WEBPACK FOOTER **
 ** ./modules/utils/galleryAPIUtils.js
 **/